import * as React from "react";
import LandingPage from "./LandingPage";
import { useNavigate } from "react-router-dom";

const SoftwareTraining = () => {
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");


  return  (
      
      <LandingPage></LandingPage>
    
  );
  
};
export default SoftwareTraining;
